/**
 * BP-21 §2: four-way compare.
 *
 * Four and not "as many as she likes": the comparison is a 2×2 grid on a
 * phone held at arm's length, and a fifth shade either shrinks the others
 * below the size at which a colour can be judged or scrolls off the screen,
 * which defeats the point of comparing.
 *
 * **Picking a fifth replaces the oldest.** The alternative — refusing until
 * she removes one — makes her do bookkeeping in the middle of choosing a
 * colour. Replacing the oldest is what a person does with four bottles and a
 * hand: the one she picked up first goes back.
 */

/** The grid's capacity. */
export const COMPARE_LIMIT = 4;

/** Add `skuId`, dropping the oldest if the grid is full. Already-in is a no-op. */
export function pick(chosen: readonly string[], skuId: string): readonly string[] {
  if (chosen.includes(skuId)) {
    return chosen;
  }
  return [...chosen, skuId].slice(-COMPARE_LIMIT);
}

/** Take `skuId` out. Unknown ids are left alone rather than throwing. */
export function drop(chosen: readonly string[], skuId: string): readonly string[] {
  return chosen.filter((id) => id !== skuId);
}

/** Whether the grid has room, for a screen that wants to say so. */
export function hasRoom(chosen: readonly string[]): boolean {
  return chosen.length < COMPARE_LIMIT;
}
